import { call, put } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { getTeamPins } from '../../redux';
function* handleGetTeamPins({ payload }) {
    const { teamId, boundaries } = payload;
    try {
        const response = (yield call(Api.getTeamPins, teamId, { boundary: boundaries }));
        yield put(getTeamPins.success(response.data));
    }
    catch (error) {
        yield put(getTeamPins.failure(error));
    }
}
export default handleGetTeamPins;
